export enum EmailValidationStatus {
    Valid = 'valid',
    Invalid = 'invalid',
    CatchAll = 'catch-all',
}
